import { useQuery } from "@apollo/client";
import { UpdateStrategy } from "@grabcad/company-server-shared/dist/types";
import { GET_PREVIEW_PRINT_VERSION } from "../VersionManagementQueries";

interface PreviewPrintVersionQueryResult {
    getPreviewPrintVersion: {
        productVersion: string;
    };
}

export function usePreviewPrintVersionQuery(updateStrategy?: UpdateStrategy, tag?: number) {
    return useQuery<PreviewPrintVersionQueryResult>(GET_PREVIEW_PRINT_VERSION, {
        variables: {
            updateStrategy,
            tag,
        },
        skip: !updateStrategy,
    });
}
